/**
 * HRAnnouncementTypeService
 * CRUD for the announcement category lookup.
 * Route: api/hrannouncementtypes
 */
import { CrudService } from '../base/CrudService';
export class HRAnnouncementTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? HRAnnouncementTypeService.DEFAULT_SERVICE_PATH,
            basePath: HRAnnouncementTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
HRAnnouncementTypeService.DEFAULT_SERVICE_PATH = 'hr';
HRAnnouncementTypeService.BASE_PATH = 'api/hrannouncementtypes';
//# sourceMappingURL=HRAnnouncementTypeService.js.map